module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('login', {
    attrs: {
      "api-url": _vm.getApiUrl(),
      "secret": _vm.getApiSecret()
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-efa4ed8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralViews/LoginPage.vue
// module id = 456
// module chunks = 1